/**
 * SubmissionHeader - Header component with quiz title and student dropdown
 */
import React from 'react';
import parse from 'html-react-parser';
import styles from './StudentSubmissionV2.module.css';

const SubmissionHeader = ({
  quizTitle,
  totalMarks,
  description,
  students,
  selectedStudent,
  onStudentChange,
  onStudentsDropdownFocus,
  shouldShowMarks,
}) => {
  // Format student display - show email only
  const formatStudentOption = (student) => {
    const email = student.email || 'Unknown';
    const status = student.submission_status || '';

    let displayText = email;

    // Show submission status - same statuses as table: 'Submitted', 'Not Uploaded', etc.
    if (status && status !== 'Submitted') {
      displayText += ` - ${status}`;
    }

    return displayText;
  };

  return (
    <div className={styles.headerCard}>
      <div className={styles.headerLeft}>
        <h1>{quizTitle}</h1>
        {shouldShowMarks && totalMarks !== null && (
          <span className={styles.totalMarks}>Total Marks: {totalMarks}</span>
        )}
        {description && (
          <div className={styles.activityDescription}>
            {typeof description === 'string' ? parse(description) : null}
          </div>
        )}
      </div>
      <div className={styles.headerRight}>
        <label>Student:</label>
        <select
          className={styles.studentDropdown}
          value={selectedStudent}
          onChange={(e) => onStudentChange(e.target.value)}
          onFocus={onStudentsDropdownFocus}
        >
          {students.length === 0 ? (
            <option value="">Loading students...</option>
          ) : (
            <>
              {/* If selected student is not in the list yet, show placeholder */}
              {selectedStudent && !students.find(s => s.email === selectedStudent) && (
                <option value={selectedStudent}>{selectedStudent}</option>
              )}
              {students.map((student) => (
                <option key={student.email} value={student.email}>
                  {formatStudentOption(student)}
                </option>
              ))}
            </>
          )}
        </select>
      </div>
    </div>
  );
};

export default SubmissionHeader;
